import {
  AppBar,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo_s.svg";
import { useAuth } from "../../contexts/AuthContext";
import Button from "../ui/Button";
import UserMenu from "./UserMenu";

const Header = () => {
  const { currentUser } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const yOffset = -80; // Adjust this value based on your header height
  const handleAboutClick = () => {
    const section = document.getElementById("about");
    if (section) {
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleFeaturesClick = () => {
    const section = document.getElementById("features");
    if (section) {
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#F2F4F8",
          color: "black",
          boxShadow: "0",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { md: "1fr auto 1fr", xs: "1fr auto" },
            alignItems: "center",
            height: { xs: 48, md: 80 },
            px: { lg: 10, md: 4, xs: 2 },
            gap: 2,
          }}
        >
          <Box
            component={Link}
            to="/"
            sx={{
              position: "relative",
              height: { xs: 23, md: 32 },
              width: "fit-content",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
            />
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 2,
            }}
          >
            <Button
              variant="text"
              sx={{
                fontWeight: 500,
                fontSize: 16,
                textTransform: "none",
                color: "#21272A",
              }}
              onClick={handleAboutClick}
            >
              About
            </Button>
            <Button
              variant="text"
              sx={{
                fontWeight: 500,
                fontSize: 16,
                textTransform: "none",
                color: "#21272A",
              }}
              onClick={handleFeaturesClick}
            >
              Features
            </Button>
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="custom"
              component={Link}
              to="/upcoming"
              sx={{
                fontWeight: 500,
                width: "auto",
                backgroundColor: "transparent",
                color: "#1890FF",
                border: "2px solid #1890FF",
                px: { md: 2, lg: "28px" },
                height: 48,
                "&:hover": {
                  border: "2px solid #40A9FF",
                },
              }}
            >
              For players
            </Button>
            <Button
              component={Link}
              to="/dashboard"
              sx={{
                height: 48,
                fontWeight: 500,
                width: "auto",
                px: { md: 2, lg: "28px" },
              }}
            >
              {currentUser ? "Dashboard" : "Login or signup"}
            </Button>
          </Box>
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              alignItems: "center",
              gap: 1,
            }}
          >
            <IconButton
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              onClick={toggleMenu}
              sx={{
                display: { md: "none" },
                color: "inherit",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              {isMenuOpen ? <IconX size={24} /> : <IconMenu2 size={24} />}
            </IconButton>
          </Box>
          {isMobile && <UserMenu open={isMenuOpen} onClose={toggleMenu} />}
        </Box>
      </AppBar>
    </>
  );
};

export default Header;
